import { format } from '@/helpers/format'

const defaultFormat = [
  {
    mask: '####-####'
  },
  {
    min: 9,
    max: 9,
    mask: '# ####-####'
  },
  {
    min: 10,
    max: 10,
    mask: '## ####-####'
  },
  {
    min: 11,
    max: 11,
    mask: '## # ####-####'
  }
]

export default (item, params = defaultFormat) => {
  if (item) {
    return format(item, params)
  }
}



// WEBPACK FOOTER //
// ./src/filters/phone.js